import { render, staticRenderFns } from "./SimulationSubmissionProfile.vue?vue&type=template&id=89fb59d6&"
import script from "./SimulationSubmissionProfile.vue?vue&type=script&lang=js&"
export * from "./SimulationSubmissionProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports